import { Typography } from "@aichat/ui/components/ui/typography";
import ButtonComponent from "../buttons/button-component";
import { LucideImage } from "lucide-react";
import { CarouselItem } from "@aichat/types/socket/widget.types";
import { stripHtmlTags } from "@aichat/aichat-lib";

function CarouselItemComponent({
  buttons,
  description,
  imageUrl,
  title,
  price,
}: CarouselItem) {
  return (
    <div className="text-left w-full h-full rounded-lg border border-secondary p-[6px] shadow-[0px_2px_4px_0px_#0000000D,0px_1px_16px_-1px_#0000001A]">
      {imageUrl ? (
        <img
          src={imageUrl}
          className="w-full aspect-video object-cover rounded-lg"
        />
      ) : (
        <div className="w-full aspect-video grid place-items-center bg-neutral-200 rounded-lg">
          <LucideImage />
        </div>
      )}
      <div className="p-2 flex gap-2 flex-col">
        <div className="flex flex-col gap-1">
          <Typography variant="pMedium">{title}</Typography>
          {price && (
            <Typography variant="subtle">
              <span className="text-muted-foreground">
                Price:&nbsp;{price.currency} {price.amount}
              </span>
            </Typography>
          )}
          <Typography
            variant="subtle"
            className="text-muted-foreground line-clamp-1"
          >
            {stripHtmlTags(description)}
          </Typography>
          <div className="flex items-start flex-col gap-2">
            {buttons.map((button, idx) => (
              <ButtonComponent
                payload={button.payload}
                className="w-full"
                key={button.id}
                variant={idx === 0 ? "carouselPrimary" : "carouselSecondary"}
              >
                {button.label}
              </ButtonComponent>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default CarouselItemComponent;
